import type { RoleOut } from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/RoleOut.ts";
import axios from "axios";

export async function getRoles(domainId: string): Promise<RoleOut[]> {
  const { data } = await axios.get<RoleOut[]>(
    `/api/hr/roles/domain/${domainId}`,
  );
  return data;
}
